import { numberFormat } from 'Components/Filters/Currencies';

// SQL mode caps the count, and floors a timed-out one to the loaded rows, flagging both with hasMore.
// Only a capped count is reformatted, so ES mode (never hasMore) renders exactly as before.
export const formatCount = (total: number, hasMore: unknown) =>
	hasMore && total > 0 ? `${numberFormat(total)}+` : `${total}`;
